// css =>
import "../../BaseStructure.css";
import Styled from "./mobile-sub-menu.module.css";

// icons =>
import MoonIcon from "../../assets/icons/moon-icon.png";
import HomeIcon from "../../assets/icons/home-icon.png";
import ChnageLangIcon from "../../assets/icons/change-lag-icon.png";

// react =>
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';

// language =>
import { getTranslation } from '../../i18n/get-translation';
import { useLanguage } from '../../context/language-context';

// context =>
import { useTheme } from '../../context/theme-context';

const MobileSunMenu = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { theme, toggleTheme } = useTheme();

    const t = (key) => getTranslation(language, key);
    const { language, changeLanguage } = useLanguage();

    const handleMenuClick = (targetKey) => {
        props.closeMenu();

        if (location.pathname === '/') {
            setTimeout(() => {
                props.onScrollTo(targetKey);
            }, 250);
        } else {
            navigate('/', { state: { scrollTo: targetKey } });
        }
    };

    return (
        <div
            className={`row ${ Styled.sub_menu_box } ${ props.isOpen ? Styled.open : "" } `}
            style={{
                backgroundColor: theme === "day" ? "#C9CCC2" : "",
                borderColor: theme === "day" ? "#474D3D" : "",
            }}>
            <div className={`col-12 ${ Styled.tittle_box } `}>
                <p>{ t('subMenuTitle') }</p>
            </div>
            
            <div
                className={`col-4 ${ Styled.icon_box } `}
                style={{ 
                    marginRight: "50px",
                    backgroundColor: theme === "day" ? "#474D3D" : ""
                }}>
                <img
                    src={ MoonIcon }
                    alt="ماه"
                    onClick={toggleTheme}
                />
            </div>
            <div
                className={`col-4 ${ Styled.icon_box } `}
                style={{
                    backgroundColor: theme === "day" ? "#474D3D" : ""
                }}>
                <img
                    alt="تغییر زبان"
                    src={ ChnageLangIcon }
                    onClick={() => changeLanguage(language === 'fa' ? 'en' : 'fa')}
                />
            </div>
            <div
                className={`col-4 ${ Styled.icon_box } `}
                onClick={() => navigate("/")}
                style={{
                    backgroundColor: theme === "day" ? "#474D3D" : ""
                }}>
                <img src={ HomeIcon } alt="خانه" />
            </div>

            <div className={`col-12 ${ Styled.options_button_box } `}>
                <button
                style={{
                    backgroundColor: theme === "day" ? "#474D3D" : ""
                }}
                    onClick={() => handleMenuClick('services')}
                >{ t('subMenuOption1') }</button>
            </div>
            <div className={`col-12 ${ Styled.options_button_box } `}>
                <button
                style={{
                    backgroundColor: theme === "day" ? "#474D3D" : ""
                }}
                    onClick={() => navigate("/products")}>{ t('subMenuOption2') }</button>
            </div>
            <div className={`col-12 ${ Styled.options_button_box } `}>
                <button
                style={{
                    backgroundColor: theme === "day" ? "#474D3D" : ""
                }}
                    onClick={() => navigate("/portfolio")}>{ t('subMenuOption3') }</button>
            </div>
            <div className={`col-12 ${ Styled.options_button_box } `}>
                <button 
                style={{
                    backgroundColor: theme === "day" ? "#474D3D" : ""
                }}
                    onClick={() => handleMenuClick('about')}
                >{ t('subMenuOption4') }</button>
            </div>
            <div className={`col-12 ${ Styled.options_button_box } `}>
                <button
                style={{
                    backgroundColor: theme === "day" ? "#474D3D" : ""
                }}
                    onClick={() => handleMenuClick('contact')}
                >{ t('subMenuOption5') }</button>
            </div>

            <div className={`col-12 ${ Styled.fotter_box } `}>
                <p>Designed & Developed by HERAM Studio</p>
            </div>
        </div>
    );
}

export default MobileSunMenu;
